import React, { useContext } from "react";
import { Divider, Grid, Text } from "@pushpress/shared-components";
import { AppContext } from "../../../context/app";
import { formatToUSD, toFixedConditional } from "../../../utils/misc";
import { PackageTotalsValues } from "./CreditsModal.types";

interface PackageTotalsProps {
  packageTotals?: PackageTotalsValues;
  loading?: boolean;
}

function PackageTotals(props: PackageTotalsProps) {
  const { packageTotals, loading } = props;

  const app = useContext(AppContext);

  const {
    subtotalValue,
    taxPercent,
    taxValue,
    discountPercent,
    discountValue,
    totalValue,
    transactionFeeDescription,
    transactionFeePercent,
    transactionFeeValue,
  } = packageTotals || {};
  const currencyIso = app.client!.currencyIso;
  const total =
    totalValue > 0 ? formatToUSD(totalValue || 0, currencyIso) : "Free";

  return (
    <>
      <Divider />
      <div className="pt-4 pr-4 pb-0 pl-4">
        {(taxValue > 0 || discountValue > 0 || transactionFeeValue > 0) && (
          <>
            <Grid container alignItems="center">
              <Grid item xs={6}>
                <Text variant="heading-5">Subtotal</Text>
              </Grid>
              <Grid item xs={6}>
                <Text variant="heading-5" align="right" component="div">
                  {formatToUSD(subtotalValue, currencyIso)}
                </Text>
              </Grid>
              {discountValue > 0 && (
                <>
                  <Grid item xs={6}>
                    <Text variant="heading-5">{`Discount ${
                      discountPercent
                        ? ` (${toFixedConditional(discountPercent)}%)`
                        : ""
                    }`}</Text>
                  </Grid>
                  <Grid item xs={6}>
                    <Text variant="heading-5" align="right" component="div">
                      {`-${formatToUSD(discountValue, currencyIso)}`}
                    </Text>
                  </Grid>
                </>
              )}
              {taxValue > 0 && (
                <>
                  <Grid item xs={6}>
                    <Text variant="heading-5">{`Tax (${toFixedConditional(
                      taxPercent,
                    )}%)`}</Text>
                  </Grid>
                  <Grid item xs={6}>
                    <Text variant="heading-5" align="right" component="div">
                      {formatToUSD(taxValue, currencyIso)}
                    </Text>
                  </Grid>
                </>
              )}
              {transactionFeeValue > 0 && (
                <>
                  <Grid item xs={6}>
                    <Text variant="heading-5">{`${transactionFeeDescription} (${toFixedConditional(
                      transactionFeePercent,
                    )}%)`}</Text>
                  </Grid>
                  <Grid item xs={6}>
                    <Text variant="heading-5" align="right" component="div">
                      {formatToUSD(transactionFeeValue, currencyIso)}
                    </Text>
                  </Grid>
                </>
              )}
            </Grid>
            <Divider vPadding={16} />
          </>
        )}
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item>
            <Text variant="heading-5">Total</Text>
          </Grid>
          <Grid item>
            <Text variant="heading-5" loading={loading} loadingCharacters={7}>
              {total}
            </Text>
          </Grid>
        </Grid>
      </div>
    </>
  );
}

export default PackageTotals;
